<template>
  <div class="task_big_box">
    <div class="task_title">
      <p
        :style="{
          color: content.content[0].textStyle.color,
          fontSize: content.content[0].textStyle.fontSize + 'rem' || '',
          fontFamily: content.content[0].textStyle.fontFamily || '',
          fontWeight: content.content[0].textStyle.fontWeight || '',
          height: 88 + 'rem',
          lineHeight: 88 + 'rem',
          marginLeft: 108 + 'rem',
        }"
      >
        <popover :content="content.content[0]"></popover>
      </p>
      <div
        class="reset"
        @click="popClick"
        v-if="content.content[0].isreset"
      ></div>
    </div>

    <div
      class="answer_operate_box"
      :style="{
        width: content.content[0].answerContent.style.width + 'rem' || '',
        height: content.content[0].answerContent.style.height + 'rem' || '',
      }"
    >
    <el-image
            class="image"
            :src="content.content[0].answerContent.src"
            :preview-src-list="[content.content[0].answerContent.src]"
            @click.stop="(e)=> {
              findChapterFrom(e)
              e.stopPropagation();
            }"
            :style="{
          width: content.content[0].answerContent.style.width + 'rem' || '',
          height: content.content[0].answerContent.style.height + 'rem' || '',
          display: 'block',
          margin: '0 auto',
        }"
        ></el-image>
      <p
        v-for="(item, index) in content.content[0].answerContent.list"
        :key="index"
        class="answer_circle"
        @click.stop="answerCircleClick($event, item, index)"
        :style="{
          width: item.width + 'rem' || '',
          height: item.height + 'rem',
          borderRadius: '50%',
          position: 'absolute',
          left: item.left + 'rem' || '',
          bottom: item.bottom + 'rem' || '',
          background: item.defaultbg ? item.defaultbg : item.bgcolor,
        }"
      >
        <img
          :src="item.type == 'error' ? type_error_img : type_correct_img"
          alt=""
          class="type_img"
          :style="{
            display:
              item.type != 'default' && !item.defaultbg ? 'block' : 'none',
          }"
        />
      </p>
    </div>
    <p
      style="width: 100%; border-bottom: 1rem solid #e3e3e3; margin-top: 40rem"
    ></p>
    <!-- 参考答案 start -->
    <div class="reference_answer_box">
      <div
        class="reference_answer_title"
        @click="referenceShow = !referenceShow"
      >
        <span>参考答案</span>
        <img
          :src="
            referenceShow
              ? require('@/assets/images/books/book1/expand_icon.png')
              : require('@/assets/images/books/book1/retract_icon.png')
          "
          alt=""
        />
      </div>
      <div
        class="reference_answer_list"
        :style="{ display: referenceShow ? 'block' : 'none' }"
      >
        <p v-for="(item, index) in content.content[0].list" :key="index" style="text-indent: 30rem;">
          <span
            v-for="(items, indexs) in item.listtContent"
            :key="indexs"
            :style="{
              color: items.textStyle.color || '',
              fontSize: items.textStyle.fontSize + 'rem' || '',
              fontFamily: items.textStyle.fontFamily || '',
              fontWeight: items.textStyle.fontWeight || '',
            }"
          >
            {{ items.text }}
          </span>
        </p>
        <el-image
            class="image"
            :src="content.content[0].image.src"
            :preview-src-list="[content.content[0].image.src]"
            @click.stop="(e)=> {
              findChapterFrom(e)
              e.stopPropagation();
            }"
            :style="{
            width: content.content[0].image.style.width + 'rem' || '',
            height: content.content[0].image.style.height + 'rem' || '',
            margin: '0 auto',
            display: 'block',
            marginTop: content.content[0].image.style.marginTop + 'rem' || '',
          }"
        ></el-image>
        <p style="text-align: center;margin-top:26rem;">
            <span v-for="(item,index) in content.content[0].footertext.fontContent" :key="index" 
                :style="{
                    color: item.textStyle.color || '',
                    fontSize: item.textStyle.fontSize + 'rem' || '',
                    fontFamily: item.textStyle.fontFamily || '',
                    fontWeight: item.textStyle.fontWeight || '',
                 }"
            >
                {{ item.text }}
            </span>
        </p>
      </div>
    </div>
    <!-- 参考答案 end -->
  </div>
</template>
   
<script>
import popover from "../text/popover.vue";
export default {
  inject: {
    findChapterFrom: {
      default: () => {},
    },
  },
  data() {
    return {
      referenceShow: false,
      type_correct_img: require("@/assets/images/books/book1/correct_icon.png"),
      type_error_img: require("@/assets/images/books/book1/error_icon.png"),
    };
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    popover,
  },
  created() {},
  methods: {
    // 答题圈点击事件
    answerCircleClick(e, item, index) {
      this.content.content[0].answerContent.list[index].defaultbg = "";
      this.findChapterFrom(e)
    },
    //重置按钮
    popClick() {
      for (
        let i = 0;
        i < this.content.content[0].answerContent.list.length;
        i++
      ) {
        this.content.content[0].answerContent.list[i].defaultbg = "rgba(2, 129, 236, 0.3)";
      }
    },
  },
};
</script>
   
<style scoped lang='scss'>
.task_big_box {
  width: calc(100% - 40px);
  margin: 0 auto 20rem;
  height: auto;
  background: #fff;
  border-radius: 10rem;
  box-shadow: 0px 3px 10px 0px rgba(32, 37, 36, 0.16);
  overflow: hidden;
  padding-top: 15rem;
}
.task_title {
  width: 100%;
  height: 88rem;
  background: url("../../../../assets/images/books/book1/task_title_bg.png")
    no-repeat;
  background-size: cover;
  position: relative;

  .pop-icon {
    width: 21rem;
    height: 20rem;
    display: inline;
    top: -10rem;
    position: relative;
  }
  .reset {
    width: 34rem;
    height: 34rem;
    background: url(~@/assets/images/books/bookExample/reset.png) center center
      no-repeat;
    background-size: contain;
    position: absolute;
    top: 10rem;
    right: 14rem;
    cursor: pointer;
  }
}

.reference_answer_box {
  padding: 0 20rem;
}
.reference_answer_title {
  height: 70rem;
  line-height: 70rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    color: #333333;
    font-size: 24rem;
    font-weight: bold;
  }
  img {
    width: 20rem;
    height: 20rem;
    cursor: pointer;
  }
}
.reference_answer_list {
  border-top: 1rem dashed #e3e3e3;
  padding:28rem 0 60rem;
}
.answer_operate_box {
  position: relative;
  //   width: 604rem;
  //   height: 462rem;
  margin: 0 auto;
}
.type_img {
  width: 34rem;
  height: 34rem;
  position: absolute;
  top: 50%;
  right: -41rem;
  transform: translateY(-50%);
}
.answer_circle {
}
</style>
